import { Component, EventEmitter, Input, Output } from '@angular/core'
import { NgClass, NgStyle, TitleCasePipe } from '@angular/common'
import { ResponsiveComponent } from '@nx-superprep/shared'
import { log } from '@nx-superprep/utils'
import { DrawerState } from '../../drawer.component'
import { PerformanceStats } from '@nx-superprep/backend/firebase'

@Component({
  selector: 'pop-ui-performance-stats',
  standalone: true,
  imports: [NgClass, NgStyle, TitleCasePipe],
  templateUrl: './performance-stats.component.html',
  styleUrls: ['./performance-stats.component.scss'],
})
export class PerformanceStatsComponent extends ResponsiveComponent {
  private _state?: DrawerState | undefined
  title = 'Units'

  @Input()
  public get state(): DrawerState | undefined {
    return this._state
  }
  public set state(value: DrawerState | undefined) {
    this._state = value
  }
  @Output() stateChange = new EventEmitter<DrawerState>()

  private _stats: PerformanceStats[] = []
  @Input()
  public get stats(): PerformanceStats[] {
    return this._stats
  }
  public set stats(value: PerformanceStats[]) {
    this._stats = value
  }

  get headingClassName() {
    return this.isWeb ? 'headingboldsmall' : 'headingboldlarge'
  }

  shouldShow(value: string | number) {
    return typeof value === 'number'
      ? value > 0
      : (Number(value.replace(/[^0-9]/g, '')) || 0) > 0
  }

  onSelect(item: PerformanceStats) {
    if (!this.state || item.name === 'completed') { return }
    log.debug('selected', item)
    if (this.state.contentState.select) { this.state.contentState.select(item).then((result) => { if (result) {this.stateChange.emit(this.state) } }) }
  }

  constructor() {
    super()
    this.rootClassName = 'performance-stats-root-class-name'
  }
}
